import { $fetch } from '@/boot/fetch'

const endpoint = '/appReturnReasons'

export default {
  /**
   * @description Get all app return reasons
   * @function getAll
   * @returns {Promise}
   */
  getAll() {
    return $fetch.peg(endpoint)
  },
}
